import * as React from 'react'

function SvgIconHand(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="hand" aria-labelledby="t-hand d-hand">
        <title id="t-hand">{'Hand'}</title>
        <desc id="d-hand">{'Open hand upwards'}</desc>
        <path d="M15 1a.5.5 0 01.5.5V12a1.001 1.001 0 001.979.206l2-9.5c.014-.068.021-.137.021-.206a.5.5 0 01.999-.027l-.996 13.454c-.026.369.151.724.465.921a1.006 1.006 0 001.032.018l4.439-2.561c.074-.043.145-.097.207-.159a.5.5 0 01.708.708c-.021.028-.056.059-.08.091L19.29 23.87a4.06 4.06 0 01-1.188.8 1.02 1.02 0 00-.601.916V32h.999v-6.415a4.991 4.991 0 001.535-1.049l7.025-8.976a1.5 1.5 0 10-2.121-2.121L20.5 16l1-13.5a1.5 1.5 0 00-3 0l-2 9.5V1.5a1.5 1.5 0 00-3 0l-1 11-1-9a1.5 1.5 0 00-3 0L9 14 7.5 7.5a1.5 1.5 0 00-3 0l2 14.5c0 1.014.377 1.939 1 2.645V32h1.001v-7.355a.997.997 0 00-.25-.66A3.008 3.008 0 017.5 22a1.04 1.04 0 00-.009-.137L5.502 7.45a.501.501 0 01.998.05c0 .076.009.151.025.225l1.5 6.5a1 1 0 001.974-.272L9.5 3.5a.5.5 0 011 0 1 1 0 00.006.11l1 9a1 1 0 00.994.89h.01a1 1 0 00.986-.91l1-11a.89.89 0 00.004-.09.5.5 0 01.5-.5" />
      </g>
    </svg>
  )
}

export default SvgIconHand
